import script from "./AcceptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptModal.vue?vue&type=script&setup=true&lang=js"

import "./AcceptModal.vue?vue&type=style&index=0&id=d905154e&lang=scss&scoped=true"
script.__scopeId = "data-v-d905154e"

export default script